<template>
  <div>
    <el-row v-if="auth.user.role !== 'company'">
      <el-form :inline="true" :model="query" class="form-inline">
        <el-form-item label="查询月份">
          <el-date-picker v-model="query.date" type="monthrange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" align="right" clearable :picker-options="endDateOpt" />
        </el-form-item>
        <el-form-item label="公司名">
          <el-input  v-model="query.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button  @click="handleExport" :loading="exportBtnLoading"><i class="bi bi-file-earmark-excel"></i>导出Excel</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="mb-2" v-else>
      <el-button type="primary" icon="el-icon-upload" @click="handleUpload">上传</el-button>
    </div>
    <div class="mb-2">

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="公司"
          width="300"
        />
        <el-table-column
          prop="month"
          label="月份"
          width="180"
        />

        <el-table-column
          prop="rate"
          label="年化利率"
        />
        <el-table-column
          prop="created_at"
          label="上传时间"
        />
        <el-table-column
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleView(scope.row.id)">查看</el-button>
            <el-button type="text" @click="handleDownload(scope.row.id)">下载</el-button>
            <el-button type="text" v-if="auth.user.role === 'company'" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="query.size"
      :total="total"
      @current-change="handleCurrentChange"
    />
    <el-dialog class="pub_dialog" :title="excelTitle" :visible.sync="visible" width="90%" :close-on-click-modal="false">
      <excel :url="excelUrl" />
    </el-dialog>
    <el-dialog title="上传台账" :visible.sync="importVisible" :close-on-click-modal="false">
      <div class="text-sm font-semibold text-[#333333] mb-[17px]">
        1.下载导入模版
      </div>
      <el-card>
        <div class="flex justify-between items-center">
          <span class="text-[17px]"><i class="bi bi-file-earmark-excel-fill text-[#1bb954] mr-[10px] text-xl"
          />导入模板</span>
          <a :href="template_url" class="downloadBtn" target="_blank">下载</a>
        </div>
      </el-card>
      <div class="text-sm font-semibold text-[#333333] mb-[17px] mt-[30px]">
        2.上传完善后的表格
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="月份" prop="month">
          <el-date-picker
            v-model="form.month"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择台账月份"
            :picker-options="endDateOpt"
          />
        </el-form-item>
        <el-form-item prop="fileid">
          <el-upload
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            accept=".xlsx"
            :file-list="fileList"
            action="/upload"
            :limit="1"
            drag
          >
            <i class="el-icon-upload"/>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过50Mb</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="importBtnLoading" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

import Layout from '@/Shared/Layout2'
import Excel from '../../components/Excel'
import axios from 'axios'

export default {
  components: {Excel},
  layout: Layout,
  props: {
    auth: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      template_url: 'https://mg01.kltb.com.cn/mcr/' + encodeURI('湖南省小额贷款公司业务台账2025.xlsx') + '?' + Date.now(),
      exportBtnLoading: false,
      endDateOpt: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      rules: {
        month: [{required: true, message: '请输入台账对应月份', trigger: 'blur'}],
        fileid: [{required: true, message: '请上传台账文件', trigger: 'change'}],
      },
      fileList: [],
      importBtnLoading: false,
      importVisible: false,
      visible: false,
      excelData: [],
      total: 0,
      query: {
        page: 1,
        size: 20,
        date: [],
        name: ''
      },
      form: {
        month: '',
        filename: '',
        fileid: ''
      },
      tableData: [],
      excelUrl: '',
      excelTitle: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getData()
  },
  methods: {
    beforeUpload(file) {

      const isSize = file.size/ 1024 / 1024 // 文件大小


      if (isSize > 50) {
        this.$message.error(`上传大小不能超过50MB!`);
        return false;
      }
      return true
    },
    handleExport() {
      console.log('handleExport')
      this.exportBtnLoading = true
      axios.get('/ledger/export', {params: this.query}).then((res) => {
        this.exportBtnLoading = false
        if (res.data.status === 1) {
          window.open(res.data.url)
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleFilter() {
      this.getData()
    },
    handleUpload() {
      this.importVisible = true
      this.fileList = []
      this.form = {
        month: '',
        filename: '',
        fileid: ''
      }
    },
    handleView(id) {
      this.visible = true
      this.getDetail(id).then(data => {
        this.excelUrl = data.url
        this.excelTitle = data.filename
      })
    },
    handleDownload(id) {
      this.getDetail(id).then(data => {
        window.open(data.url)
      })
    },
    handleDelete(id) {
      this.$confirm('确定删除?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        axios.post('/ledger/delete', {id: id}).then(res => {
          if (res.data.status === 1) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    handleRemove(file, fileList) {
      this.fileList = []
      this.form.filename = ''
      this.form.fileid = ''
    },
    handleExceed(files, fileList) {
      this.$message.warning('请删除原有上传文件后重新上传新文件')
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1)
      // console.log(file, fileList, this.fileList)
      if ('response' in file) {
        this.form.filename = file.response.name
        this.form.fileid = file.response.id
      }
    },
    onSubmit() {
      // console.log(this.form)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.importBtnLoading = true
          axios.post('/ledger/upload', this.form).then(res => {
            this.importBtnLoading = false
            if (res.data.status === 1) {
              this.importVisible = false
              this.$message.success('上传成功')
              this.getData()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getData()
    },
    getData() {
      axios.get('/ledger/list', {params: this.query}).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    getDetail(id) {
      return new Promise((resolve, reject) => {
        axios.get('/ledger/detail', {params: {id: id}}).then(res => {
          resolve(res.data.data)
        })
      })

    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload, ::v-deep .el-upload-dragger {
  width: 100%;
}

.downloadBtn {
  display: inline-block;
  width: 81px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #2196f3;
  border-radius: 32px;
  background-color: #fff;
  font-size: 16px;
  color: #1e88e5;
}

</style>
